import React from "react";
import { Plus, Star } from "lucide-react";
import WatchSpotCard from "./WatchSpotCard";
import { getTranslationsForLanguage } from "@/i18n";

const storageKey = "marstick_daily_weather_watchlist";

export default function WeatherWatchlist({ currentLocation, lang = "en" }) {
  const t = getTranslationsForLanguage(lang, "dailyBriefing").watchlist;
  const [spots, setSpots] = React.useState([]);
  const [name, setName] = React.useState("");

  React.useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(storageKey) || "null");
    const userSaved = Array.isArray(saved) ? saved.filter((spot) => !["tel-aviv", "athens"].includes(spot.id)) : [];
    if (userSaved.length) setSpots(userSaved);
  }, []);

  React.useEffect(() => {
    if (!currentLocation?.lat || !currentLocation?.lng || spots.length) return;
    setSpots([{ id: "current-location", name: [currentLocation.city, currentLocation.country].filter(Boolean).join(", ") || t.defaultSpot, lat: currentLocation.lat, lng: currentLocation.lng }]);
  }, [currentLocation?.lat, currentLocation?.lng, currentLocation?.city, currentLocation?.country, spots.length, t.defaultSpot]);

  React.useEffect(() => {
    if (!currentLocation?.lat || !currentLocation?.lng || spots[0]?.id !== "current-location") return;
    const nextName = [currentLocation.city, currentLocation.country].filter(Boolean).join(", ") || t.defaultSpot;
    if (spots[0].name === nextName && spots[0].lat === currentLocation.lat && spots[0].lng === currentLocation.lng) return;
    setSpots([{ ...spots[0], name: nextName, lat: currentLocation.lat, lng: currentLocation.lng }, ...spots.slice(1)]);
  }, [currentLocation?.lat, currentLocation?.lng, currentLocation?.city, currentLocation?.country, spots, t.defaultSpot]);

  const save = (next) => { setSpots(next); localStorage.setItem(storageKey, JSON.stringify(next)); };
  const addCurrent = () => {
    const label = name.trim() || currentLocation?.city || t.defaultSpot;
    const spot = { id: `${Date.now()}`, name: label, lat: currentLocation?.lat || 32.0853, lng: currentLocation?.lng || 34.7818 };
    save([spot, ...spots]); setName("");
  };
  const remove = (id) => save(spots.filter((spot) => spot.id !== id));

  return (
    <article className="rounded-[2rem] border border-border bg-card p-6 shadow-xl shadow-ocean/5 lg:col-span-2">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div><p className="text-sm font-black uppercase tracking-[0.18em] text-primary">{t.eyebrow}</p><h3 className="mt-2 text-2xl font-black">{t.title}</h3></div>
        <div className="flex gap-2"><input value={name} onChange={(e) => setName(e.target.value)} placeholder={t.placeholder} className="rounded-2xl border border-input bg-background px-4 text-sm" /><button type="button" onClick={addCurrent} className="inline-flex items-center gap-2 rounded-2xl bg-primary px-4 py-2 text-sm font-black text-primary-foreground"><Plus className="h-4 w-4" /> {t.save}</button></div>
      </div>
      <div className="mt-5 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        {spots.map((spot) => <WatchSpotCard key={spot.id} spot={spot} onRemove={spot.id === "current-location" ? null : remove} lang={lang} />)}
      </div>
      <p className="mt-4 flex items-center gap-2 text-sm text-muted-foreground"><Star className="h-4 w-4 text-primary" /> {t.footer}</p>
    </article>
  );
}